import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import RefundRequest from "../../magData/Bus/RefundRequest";
import RefundResponse from "../../magData/Bus/RefundResponse";

function BusRefundPage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Bus Refund Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/bus/refund</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(RefundRequest, null, 2)}
            </pre>


          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>success</td>
                  <td>success</td>
                  <td>boolean </td>
                  <td>None.</td>
                </tr>
                <tr>
                  <td>code</td>
                  <td>
                    code
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>ticketPrice</td>
                  <td>
                    ticketPrice
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>refundAmount</td>
                  <td>
                    refundAmount
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>userId</td>
                  <td>
                    userId
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>username</td>
                  <td>
                    username
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>refundCode</td>
                  <td>
                    refundCode
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(RefundResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default BusRefundPage;